import { render, staticRenderFns } from "./LCL.vue?vue&type=template&id=6d15f38c&scoped=true"
import script from "./LCL.vue?vue&type=script&lang=js"
export * from "./LCL.vue?vue&type=script&lang=js"
import style0 from "./LCL.vue?vue&type=style&index=0&id=6d15f38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15f38c",
  null
  
)

export default component.exports